/**
 * Schedule entry point used by the dashboard. Phase 9A replaced the single 1,900-line calendar
 * with components/scheduling/* (Today board, Coverage week, Clinicians, Month, List).
 */
import React from 'react';
import ScheduleShell, { ScheduleView } from './scheduling/ScheduleShell';

const SUBSECTION_VIEW: Record<string, ScheduleView> = { Today: 'today', Week: 'coverage' };

const Schedule: React.FC<{ subsection?: string | null }> = ({ subsection }) => (
  <ScheduleShell initialView={subsection ? SUBSECTION_VIEW[subsection] : undefined} />
);

export default Schedule;
